import React from 'react'

const S = {
  wrap: { maxWidth: 800, margin: '0 auto', padding: '3rem 1.5rem 5rem', fontFamily: "'DM Sans', sans-serif", color: '#1a1a1a', lineHeight: 1.8 },
  h1: { fontSize: '2rem', fontWeight: 700, marginBottom: '.5rem', color: '#1a3c2b' },
  sub: { color: '#666', fontSize: '.9rem', marginBottom: '2.5rem' },
  h2: { fontSize: '1.15rem', fontWeight: 700, marginTop: '2rem', marginBottom: '.5rem', color: '#1a3c2b' },
  p: { marginBottom: '1rem', color: '#333' },
  ul: { paddingLeft: '1.5rem', marginBottom: '1rem', color: '#333' },
  li: { marginBottom: '.4rem' },
}

export default function TermsOfService() {
  return (
    <div style={S.wrap}>
      <h1 style={S.h1}>Terms of Service</h1>
      <p style={S.sub}>Last updated: June 2026 &nbsp;·&nbsp; Revive Skin &amp; Hair Experts</p>

      <h2 style={S.h2}>1. Services</h2>
      <p style={S.p}>Revive Skin &amp; Hair Experts provides online dermatology consultations, skin analysis, and curated skincare products. By using our platform you agree to these terms.</p>

      <h2 style={S.h2}>2. Medical Disclaimer</h2>
      <p style={S.p}>Revive provides general dermatology guidance. Our services are not a substitute for emergency medical care or in-person treatment when required. Always consult a qualified doctor for urgent conditions.</p>
      <p style={S.p}>AI skin analysis results are indicative only and must be reviewed by a qualified dermatologist before any diagnosis or treatment decision is made.</p>

      <h2 style={S.h2}>3. Appointments</h2>
      <ul style={S.ul}>
        <li style={S.li}>Appointments must be booked and paid for in advance</li>
        <li style={S.li}>Please be available at your chosen time slot</li>
        <li style={S.li}>Online consultations are conducted via Google Meet</li>
        <li style={S.li}>Rescheduling requests must be made at least 2 hours before the appointment</li>
      </ul>

      <h2 style={S.h2}>4. Payments</h2>
      <p style={S.p}>All payments are processed securely via Razorpay. Prices are in Indian Rupees (INR) and inclusive of applicable taxes. Revive reserves the right to change pricing with prior notice.</p>

      <h2 style={S.h2}>5. User Responsibilities</h2>
      <ul style={S.ul}>
        <li style={S.li}>Provide accurate health information during consultations</li>
        <li style={S.li}>Keep your login credentials confidential</li>
        <li style={S.li}>Do not share your OTP with anyone</li>
        <li style={S.li}>Do not misuse or attempt to hack our platform</li>
      </ul>

      <h2 style={S.h2}>6. Intellectual Property</h2>
      <p style={S.p}>All content on Revive including text, images, AI models, and software is the property of Furaise Mineral Private Limited. Unauthorised reproduction is prohibited.</p>

      <h2 style={S.h2}>7. Governing Law</h2>
      <p style={S.p}>These terms are governed by the laws of India. Any disputes shall be subject to the jurisdiction of courts in Nellore, Andhra Pradesh.</p>

      <h2 style={S.h2}>8. Contact</h2>
      <p style={S.p}>For queries about these terms, contact us at <strong>support@revivehc.com</strong>.</p>
    </div>
  )
}
